import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { Pagination, Autoplay, Grid} from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {

        const SliderBanner = new Swiper('.swiper-home-ratings', {
            modules: [Pagination, Autoplay, Grid],
            slidesPerView: 1,
            spaceBetween: 20,
            grid: {
                rows: 4,
                fill: 'row',
            },
            pagination: {
                el: '.swiper-home-rating-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    grid: {
                        rows: 2,
                    },
                    spaceBetween: 18,
                },
                1024: {
                    slidesPerView: 4,
                    grid: {
                        rows: 1,
                    },
                    spaceBetween: 18,
                },
            }
        });
});



